import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string().required("Please enter your email"),
    password: Yup.string()
      .required("Please enter your Password")
      .test(
        "not-only-whitespace",
        "Password cannot contain only spaces.",
        value =>
          value !== undefined &&
          value !== null &&
          String(value).trim().length > 0
      )
  }),
  mapPropsToValues: props => ({
    email: "",
    password: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
